import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { skillsType } from "../../../common/interfaces/myProfile/personalDetails/skillsType";
// Define a type for the slice state

// Define the initial state using that type

const skillsSlice = createSlice({
  name: "skillsDetails",

  initialState: { skills: [] },
  reducers: {
    getAllEmployeeSkills: (state: any, action: PayloadAction<skillsType>) => {
      const payload = action.payload;
      state.skills = payload;
    },
    resetEmployeeSkills: (state) => {
      state.skills = [];
    },
  },
});

export const { getAllEmployeeSkills, resetEmployeeSkills } =
  skillsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default skillsSlice.reducer;
